<template>
  <el-container class="workspace-page issues-page">
    <el-header height="auto" class="workspace-toolbar issue-toolbar">
      <div class="issue-toolbar-layout">
        <div class="issue-filter-grid">
          <label class="issue-filter issue-filter--date">
            <span class="issue-filter-label">{{ $t("创建日期") }}</span>
            <el-date-picker
                v-model="deadline"
                class="issue-filter-control"
                align="right"
                :end-placeholder="$t('截止日期')"
                :range-separator="$t('至')"
                :start-placeholder="$t('起始日期')"
                type="daterange"
                popper-class="responsive-date-picker"
                unlink-panels
                value-format="yyyy-MM-dd"
                @change="deadlineChanged">
            </el-date-picker>
          </label>

          <label class="issue-filter">
            <span class="issue-filter-label">{{ $t("问题状态") }}</span>
            <el-select v-model="issueStatus" class="issue-filter-control" clearable :placeholder="$t('全部问题')" @change="issueStatusChanged">
              <el-option
                  v-for="item in issueStatusList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </label>

          <label class="issue-filter">
            <span class="issue-filter-label">{{ $t("活动") }}</span>
            <el-select v-model="activityId" class="issue-filter-control" clearable :placeholder="$t('全部活动')" @change="activityChanged">
              <el-option
                  v-for="item in activities"
                  :key="item.activityId"
                  :label="item.localeKey ? $t(item.localeKey) : item.name"
                  :value="item.activityId">
              </el-option>
            </el-select>
          </label>

          <label class="issue-filter">
            <span class="issue-filter-label">{{ $t("责任部门") }}</span>
            <el-select v-model="departmentId" class="issue-filter-control" clearable :placeholder="$t('全部部门')" @change="departmentChanged">
              <el-option
                  v-for="item in departments"
                  :key="item.departmentId"
                  :label="item.localeKey ? $t(item.localeKey) : item.name"
                  :value="item.departmentId">
              </el-option>
            </el-select>
          </label>
        </div>

        <div class="issue-actions">
          <el-button type="primary" icon="el-icon-plus" @click="openRecordIssueDialog">{{ $t("记录问题") }}</el-button>
          <el-button v-if="user.roleId===1" @click="exportAsExcelButtonClicked">{{ $t("导出 Excel") }}</el-button>
          <div v-if="user.userId===6236" class="ppt-export">
            <el-button @click="exportAsPPTButtonClicked()">{{ $t("导出 PPT") }}</el-button>
            <el-progress
                v-if="pptExporting"
                :percentage="pptExportProgress"
                class="ppt-export-progress">
            </el-progress>
          </div>
        </div>
      </div>

      <div class="issue-toolbar-meta">
        <span class="issue-total">
          <i class="el-icon-document" aria-hidden="true"></i>
          {{ $t("共 {p0} 个问题", { p0: countOfAllIssues }) }}
        </span>
        <div v-if="user.roleId===1 && issues.length !== 0" class="issue-batch-actions">
          <button class="select-all-button" type="button" @click="toggleSelectAllIssues">
            {{ allLoadedIssuesSelected ? $t("取消全选") : $t("全选当前列表") }}
          </button>
          <template v-if="itemSelected.length !== 0">
            <span class="selected-count">{{ $t("已选择 {p0} 项", { p0: itemSelected.length }) }}</span>
            <el-button size="mini" @click="openEditIssueDialog">{{ $t("修改部门") }}</el-button>
            <el-button size="mini" type="danger" @click="deleteButtonClicked">{{ $t("删除") }}</el-button>
          </template>
        </div>
      </div>
    </el-header>
    <el-dialog
        :visible.sync="excelDialogVisible"
        :title="$t('提示')"
        width="30%">
      <span>{{ $t("您确定要导出{p0}问题为Excel吗?", { p0: dialogContent }) }}</span>
      <span slot="footer" class="dialog-footer">
                            <el-button @click="excelDialogVisible = false">{{ $t("取 消") }}</el-button>
                            <el-button type="primary" @click="exportAsExcelButtonConfirmed()">{{ $t("确 定") }}</el-button>
                        </span>
    </el-dialog>
    <el-dialog
        :visible.sync="pptDialogVisible"
        :title="$t('提示')"
        width="30%">
      <span>{{ $t("您确定要导出{p0}问题为PPT吗?", { p0: dialogContent }) }}</span>
      <span slot="footer" class="dialog-footer">
                            <el-button @click="pptDialogVisible = false">{{ $t("取 消") }}</el-button>
                            <el-button type="primary" @click="exportAsPPTButtonConfirmed()">{{ $t("确 定") }}</el-button>
                        </span>
    </el-dialog>
    <el-dialog
        :visible.sync="deleteDialogVisible"
        :title="$t('提示')"
        width="30%">
      <span>{{ $t("您是否要删除选中的{p0}个问题？", { p0: itemSelected.length }) }}</span>
      <span slot="footer" class="dialog-footer">
                            <el-button @click="deleteDialogVisible = false">{{ $t("取 消") }}</el-button>
                            <el-button type="danger" @click="deleteButtonConfirmed">{{ $t("确 定") }}</el-button>
                        </span>
    </el-dialog>

    <el-dialog
        :visible.sync="editIssueDialog.visible"
        :title="$t('编辑问题')"
        width="30%">
      <el-select v-model="editIssueDialog.departmentId" :placeholder="$t('责任部门')">
        <el-option
            v-for="item in departments"
            :key="item.departmentId"
            :label="item.localeKey ? $t(item.localeKey) : item.name"
            :value="item.departmentId">
        </el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
                    <el-button @click="editIssueDialog.visible = false">{{ $t("取 消") }}</el-button>
                    <el-button type="primary" @click="changeDepartmentClicked">{{ $t("确 定") }}</el-button>
                </span>
    </el-dialog>

    <component :is="issueEditorComponent"
        :key="issueEditorComponent"
        :visible.sync="recordIssueDialogVisible"
        :title="editingIssue ? $t('编辑问题') : $t('记录问题')"
        width="60%"
        size="min(560px, 100vw)"
        direction="rtl"
        :fullscreen="isMobileIssueEditor"
        :custom-class="issueEditorClass"
        :wrapper-closable="true"
        :before-close="closeIssueForm"
        :close-on-click-modal="false"
        @closed="resetRecordIssueForm">
      <el-form ref="recordIssueForm" :model="recordIssueForm" :rules="recordIssueRules"
          :label-position="isMobileIssueEditor ? 'top' : 'right'" label-width="auto">
        <el-form-item :label="$t('问题描述')" prop="description">
          <el-input
              v-model="recordIssueForm.description"
              type="textarea"
              :rows="4"
              maxlength="255"
              show-word-limit
                :placeholder="$t('请详细描述问题发生的位置、现象、原因…')" />
        </el-form-item>
        <el-form-item :label="$t('问题图片')">
          <el-upload
              class="issue-upload"
              multiple
              accept="image/*"
              list-type="picture-card"
              :file-list="recordIssueFileList"
              :http-request="handleIssueImageUpload"
              :limit="4"
              :on-change="handleIssueImageChange"
              :on-remove="handleIssueImageRemove"
              :on-exceed="handleIssueImageExceed">
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item :label="$t('活动')">
          <el-select v-model="recordIssueForm.activityId" clearable :placeholder="$t('请选择活动')">
            <el-option
                v-for="item in activityOptionsForForm"
                :key="item.activityId"
                :label="item.localeKey ? $t(item.localeKey) : item.name"
                :value="item.activityId" />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('责任部门')" prop="departmentId">
          <el-select v-model="recordIssueForm.departmentId" clearable :placeholder="$t('请选择责任部门')">
            <el-option
                v-for="item in departmentOptionsForForm"
                :key="item.departmentId"
                :label="item.localeKey ? $t(item.localeKey) : item.name"
                :value="item.departmentId" />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('问题分类')">
          <el-select v-model="recordIssueForm.issueTypeId" clearable :placeholder="$t('请选择问题分类')">
            <el-option
                v-for="item in issueTypes"
                :key="item.id"
                :label="item.localeKey ? $t(item.localeKey) : item.name"
                :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('整改期限')">
          <el-date-picker
              v-model="recordIssueForm.deadline"
              type="date"
              value-format="yyyy-MM-dd"
              :placeholder="$t('请选择日期')" />
        </el-form-item>
        <el-form-item :label="$t('提醒谁')">
          <el-select
              v-model="recordIssueForm.mentionedUsers"
              value-key="userId"
              multiple
              filterable
              remote
              clearable
              reserve-keyword
              :placeholder="$t('搜索公司员工')"
              :remote-method="fetchEmployeeOptions"
              :loading="employeeLoading">
            <el-option
                v-for="item in employeeOptions"
                :key="item.userId"
                :label="item.localeKey ? $t(item.localeKey) : item.name"
                :value="item" />
          </el-select>
        </el-form-item>
      </el-form>
      <div :slot="issueEditorUsesDrawer ? 'default' : 'footer'" :class="editingIssue ? 'issue-editor-footer' : 'dialog-footer'">
        <el-button :disabled="recordIssueSubmitting" @click="recordIssueDialogVisible = false">{{ $t("取 消") }}</el-button>
        <el-button type="primary" :loading="recordIssueSubmitting" @click="submitRecordIssue">{{ editingIssue ? $t("保存") : $t("提 交") }}</el-button>
      </div>
    </component>

    <el-main class="workspace-content">
      <div class="issue-cards">
        <article
          v-for="issue in issues"
          :key="issue.issueId"
          class="issue-thread">
        <el-card
          :class="['issue-card', {'issue-card--selected': isIssueSelected(issue)}]"
          :body-style="{ padding: '0' }"
          shadow="never">
          <header class="issue-card-header">
            <span :class="['issue-card-status', 'issue-card-status--' + issue.issueStatus]">
              {{ $t(['待解决', '待验收', '已验收'][issue.issueStatus]) }}
            </span>
            <div class="issue-card-header-actions">
              <el-button v-if="canEditIssue(issue)" class="issue-edit-trigger" type="primary" plain size="mini"
                icon="el-icon-edit" :aria-label="$t('编辑问题')" :title="$t('编辑问题')"
                @click="openIssueEditor(issue)" />
              <button
                type="button"
                :class="['issue-card-selector', {'issue-card-selector--selected': isIssueSelected(issue)}]"
                :aria-pressed="isIssueSelected(issue) ? 'true' : 'false'"
                :aria-label="isIssueSelected(issue) ? $t('取消选择问题') : $t('选择问题')"
                :title="isIssueSelected(issue) ? $t('取消选择') : $t('选择')"
                @click="toggleIssueSelection(issue, !isIssueSelected(issue))">
                <i v-if="isIssueSelected(issue)" class="el-icon-check" aria-hidden="true"></i>
              </button>
            </div>
          </header>

          <section class="issue-card-content" :aria-label="$t('问题概览')">
            <h3 class="issue-card-section-title">{{ $t("问题概览") }}</h3>
            <div :class="['issue-card-description', {'issue-card-description--empty': !issue.description}]">
              {{ issue.description || $t("暂无问题描述") }}
            </div>
            <div v-if="issue.images && issue.images.length" class="issue-card-images">
              <div v-for="(image, index) in issue.images.slice(0, 4)"
                :key="`${issue.issueId}-image-${index}`" class="issue-card-image">
                <el-image :src="image" :preview-src-list="issue.images" fit="cover" :alt="$t('问题图片')" lazy />
                <span v-if="index === 3 && issue.images.length > 4" class="issue-card-image-more">
                  +{{ issue.images.length - 4 }}
                </span>
              </div>
            </div>
            <div v-if="issue.issueType || issue.activity || (issue.theUsersMentioned && issue.theUsersMentioned.length)"
              class="issue-card-tags">
              <span v-if="issue.activity" class="issue-card-tag issue-card-tag--activity">
                <i class="el-icon-notebook-2" aria-hidden="true"></i>
                {{ getIssueActivityLabel(issue) }}
              </span>
              <span v-if="issue.issueType" class="issue-card-tag">#{{ issue.issueType.name }}</span>
              <span v-for="mentionedUser in (issue.theUsersMentioned || [])"
                :key="`${issue.issueId}-mentioned-${mentionedUser.userId}`" class="issue-card-tag">
                @{{ mentionedUser.name }}
              </span>
            </div>
            <div class="issue-card-overview">
              <div class="issue-card-context">
                <span class="issue-card-department" :title="$t('责任部门：{p0}', { p0: getIssueDepartmentLabel(issue) })">
                  <i class="el-icon-office-building" aria-hidden="true"></i>
                  <span>{{ getIssueDepartmentLabel(issue) }}</span>
                </span>
              </div>
              <div class="issue-card-timing">
                <span class="issue-card-recorded" :title="$t('记录人及记录时间')">
                  <span class="issue-card-recorder-name">{{ (issue.recorder && issue.recorder.name) || $t("未知用户") }}</span> {{ $t("记录于{p0}", { p0: issue.dateCreated || '—' }) }}
                </span>
                <span v-if="issue.deadline" class="issue-card-deadline" :title="$t('整改期限')"
                  :class="{ 'issue-card-deadline--overdue': isIssueOverdue(issue) }">
                  <i class="el-icon-time" aria-hidden="true"></i>
                  <span>{{ $t("{p0} 截止", { p0: issue.deadline }) }}</span>
                </span>
              </div>
            </div>
          </section>
        </el-card>

          <issue-solution-list :issue="issue" :user="user" :can-approve="canApprove"
            @changed="handleIssueChanged(issue, $event)" />

          <issue-card-actions v-if="issue.issueStatus === ISSUE_STATUS_UNSOLVED"
            class="issue-thread__composer"
            :issue="issue" :user="user" mode="solve"
            @changed="handleIssueChanged(issue, $event)" />
        </article>
        <div v-if="!issues.length" class="issue-empty">{{ $t("暂无问题") }}</div>
      </div>
      <div class="load-more">
        <i v-if="loadingMore" class="el-icon-loading load-more-spinner"></i>
        <span v-else-if="!hasMore && issues.length" class="load-more-tip">{{ $t("已加载全部") }}</span>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import { t } from "@/i18n";
import axios from "axios";
import app from "@/App";
import { canEditIssue, canDeleteIssue } from "@/utils/issuePermissions";
import IssueCardActions from "./IssueCardActions.vue";
import IssueSolutionList from "./IssueSolutionList.vue";
import { getCompanyIdFromToken } from "@/utils/refreshToken";

export default {
  name: "Issues",
  components: { IssueCardActions, IssueSolutionList },
  data() {
    return {
      user: {},
      issues: [],
      deadline: null,
      excelDialogVisible: false,

      pptDialogVisible: false,
      deleteDialogVisible: false,
      countOfAllIssues: 0,
      searchCriteria: {
        startOfDeadline: null,
        endOfDeadline: null,
      },
      activeIndex: '1',
      activeIndex2: '1',
      itemSelected: [],
      ISSUE_STATUS_UNSOLVED: 0,
      ISSUE_STATUS_UNACCEPTED: 1,
      ISSUE_STATUS_ACCEPTED: 2,

      issueStatus: null,

      departmentId: null,
      departments: [],
      rootDepartmentId: null,

      editIssueDialog: {
        visible: false,
        departmentId: null
      },
      editingIssue: null,
      recordIssueDialogVisible: false,
      recordIssueSubmitting: false,
      recordIssueForm: {
        description: '',
        images: [],
        activityId: null,
        departmentId: null,
        issueTypeId: null,
        deadline: null,
        mentionedUsers: [],
      },
      recordIssueFileList: [],

      employeeOptions: [],
      employeeLoading: false,
      issueTypes: [],

      activities: [],
      activityId: null,
      controller: new AbortController(),
      pptExporting: false,
      pptExportProgress: 0,
      nextCursor: null,
      loadingMore: false,
      hasMore: true,
      scrollHandler: null,
      autoSelectLoadedIssues: false,
      isMobileViewport: false,
      issueEditorResizeHandler: null,
    }
  },
  computed: {
    isMobileIssueEditor() {
      return Boolean(this.editingIssue) && this.isMobileViewport;
    },
    issueEditorUsesDrawer() {
      return Boolean(this.editingIssue) && !this.isMobileViewport;
    },
    issueEditorComponent() {
      return this.issueEditorUsesDrawer ? 'el-drawer' : 'el-dialog';
    },
    issueEditorClass() {
      if (!this.editingIssue) return '';
      return this.isMobileIssueEditor
        ? 'issue-editor-panel issue-editor-panel--mobile'
        : 'issue-editor-panel';
    },
    dialogContent() {
      return this.itemSelected.length
        ? t('选中的 {p0} 个', { p0: this.itemSelected.length })
        : t('所有符合筛选条件');
    },
    issueStatusList() {
      return [{
        value: null,
        label: t("全部")
      }, {
        value: 0,
        label: t("待解决")
      }, {
        value: 1,
        label: t("待验收")
      }, {
        value: 2,
        label: t("已验收")
      }];
    },
    recordIssueRules() {
      return {
        description: [{required: !this.editingIssue, message: t("请输入问题描述"), trigger: 'blur'}],
        departmentId: [{required: true, message: t("请选择责任部门"), trigger: 'change'}],
        issueTypeId: [{required: true, message: t("请选择问题分类"), trigger: 'change'}],
        deadline: [{required: true, message: t("请选择整改期限"), trigger: 'change'}],
      };
    },
    canApprove() {
      return this.user.roleId === 1 || this.user.approvalRights === true;
    },
    companyId() {
      return getCompanyIdFromToken() || (this.user && this.user.company && this.user.company.companyId) || null;
    },
    activityOptionsForForm() {
      return Array.isArray(this.activities)
        ? this.activities.filter(item => item && item.activityId !== null)
        : [];
    },
    departmentOptionsForForm() {
      return Array.isArray(this.departments)
        ? this.departments.filter(item => item && item.departmentId && item.departmentId !== 0)
        : [];
    },
    allLoadedIssuesSelected() {
      return this.issues.length > 0 && this.issues.every(issue => this.isIssueSelected(issue));
    },
  },
  methods: {
    async handleIssueChanged(issue, change) {
      // Update only this card so other cards retain their drafts and uploads.
      const updated = { ...issue, issueStatus: change.status,
        issueStatusName: [t("待解决"), t("待验收"), t("已验收")][change.status] };
      if (change.solution) {
        updated.solutions = [{ ...change.solution, _awaitingDetails: true }, ...(issue.solutions || [])];
      } else {
        const reviewed = (issue.solutions || []).find(solution => solution.answerId === change.solutionId);
        updated.solutions = reviewed
          ? [{ ...reviewed, result: change.result, rejectionReason: change.reason },
            ...issue.solutions.filter(solution => solution.answerId !== change.solutionId)]
          : (issue.solutions || []);
      }
      const replaceCard = (record) => {
        const index = this.issues.findIndex(item => item.issueId === issue.issueId);
        if (index === -1) return;
        const statuses = this.searchCriteria.issueStatus;
        if (statuses && !statuses.includes(record.issueStatus)) {
          this.issues.splice(index, 1);
          this.itemSelected = this.itemSelected.filter(item => item.issueId !== issue.issueId);
          this.countOfAllIssues = Math.max(0, this.countOfAllIssues - 1);
        } else {
          this.$set(this.issues, index, record);
          this.itemSelected = this.itemSelected.map(item => item.issueId === issue.issueId ? record : item);
        }
      };
      replaceCard(updated);
      try {
        const { data } = await axios.get(`${app.url}/issues/${issue.issueId}`);
        // A filter change may have replaced the list while the request was running.
        if (data && this.issues.includes(updated)) {
          const reviewed = (data.solutions || []).find(solution => solution.answerId === change.solutionId);
          if (reviewed) {
            data.solutions = [reviewed, ...data.solutions.filter(solution => solution.answerId !== change.solutionId)];
          }
          replaceCard({ ...data, issueStatusName: [t("待解决"), t("待验收"), t("已验收")][data.issueStatus] });
        }
      } catch (error) {
        this.$message.warning(t("操作已成功，最新详情加载失败，可刷新页面查看"));
      }
    },
    exportAsPPTButtonClicked() {
      this.pptDialogVisible = true
    },

    exportAsPPTButtonConfirmed() {
      this.pptDialogVisible = false
      this.exportAsPPT()
    },
    exportAsPPT() {
      this.pptExporting = true;
      this.pptExportProgress = 0;
      const idempotencyKey = typeof crypto !== 'undefined' && crypto.randomUUID
        ? crypto.randomUUID()
        : Date.now().toString() + '-' + Math.random().toString(36).substring(2);
      axios.post(app.url + '/issues/export/ppt-task', {
        searchStartDate: this.deadline && this.deadline[0],
        searchEndDate: this.deadline && this.deadline[1],
        issueIds: this.itemSelected.map(v => v.issueId),
        issueStatuses: this.searchCriteria.issueStatus,
        activityId: this.searchCriteria.activityId,
        departmentId: this.searchCriteria.departmentId,
      }, {
        responseType: 'arraybuffer',
        headers: { 'Idempotency-Key': idempotencyKey },
      }).then(() => {
        if (this.$refs.multipleTable) {
          this.$refs.multipleTable.clearSelection();
        }
      });
    },
    onExportProgress(e) {
      const progress = Number(e.detail);
      this.pptExportProgress = progress;
      if (progress >= 100) {
        this.pptExporting = false;
        this.pptExportProgress = 100;
        this.$message({
          message: t("导出成功！！！"),
          type: "success"
        });
      } else {
        this.pptExporting = true;
      }
    },
    exportAsExcelButtonClicked() {
      this.excelDialogVisible = true
    },
    exportAsExcelButtonConfirmed() {
      this.excelDialogVisible = false;
      axios.post(app.url + '/issues/exportAsExcel', {
        searchStartDate: this.deadline ? this.deadline[0] : null,
        searchEndDate: this.deadline ? this.deadline[1] : null,
        activityId: this.activityId,
        departmentId: this.departmentId,
        issueStatuses: this.issueStatus == null ? null : [this.issueStatus],
        issueIds: this.itemSelected.map(v => v.issueId),
      }, {responseType: 'arraybuffer',}).then(res => {
        const blob = new Blob([res.data]); // 创建blob对象

        const fileName = t("爱精益-问题列表-") + new Intl.DateTimeFormat(this.$localeState.locale, {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          timeZone: 'Asia/Shanghai', // 中国时区
          hour12: false
        }).format(new Date()) + ".xls";
        const elink = document.createElement("a"); // 创建的标签
        elink.download = fileName;
        elink.style.display = "none";
        elink.href = URL.createObjectURL(blob); // 创建url
        document.body.appendChild(elink); // 把 创建的标签追加到body里
        elink.click();
        URL.revokeObjectURL(elink.href); // 释放URL 对象
        document.body.removeChild(elink); // 移除标签
        this.$message({
          message: t("导出成功！！！"),
          type: "success"
        });
        if (this.$refs.multipleTable) {
          this.$refs.multipleTable.clearSelection();
        }
      });
    },
    isIssueSelected(issue) {
      return this.itemSelected.some(item => item.issueId === issue.issueId);
    },
    selectLoadedIssues() {
      const selectedById = new Map(this.itemSelected.map(item => [item.issueId, item]));
      this.issues.forEach((issue) => {
        selectedById.set(issue.issueId, issue);
      });
      this.itemSelected = Array.from(selectedById.values());
    },
    clearLoadedIssuesSelection() {
      const loadedIssueIds = new Set(this.issues.map(issue => issue.issueId));
      this.itemSelected = this.itemSelected.filter(item => !loadedIssueIds.has(item.issueId));
    },
    toggleSelectAllIssues() {
      if (this.allLoadedIssuesSelected) {
        this.clearLoadedIssuesSelection();
        this.autoSelectLoadedIssues = false;
        return;
      }
      this.selectLoadedIssues();
      this.autoSelectLoadedIssues = true;
    },
    toggleIssueSelection(issue, checked) {
      if (checked) {
        if (!this.isIssueSelected(issue)) {
          this.itemSelected = this.itemSelected.concat(issue);
        }
      } else {
        this.itemSelected = this.itemSelected.filter(item => item.issueId !== issue.issueId);
        this.autoSelectLoadedIssues = false;
      }
      if (!this.allLoadedIssuesSelected) {
        this.autoSelectLoadedIssues = false;
      }
    },
    deleteButtonClicked() {
      if (!this.itemSelected.every(issue => canDeleteIssue(issue, this.user))) return;
      let issueIds = [];

      this.itemSelected.forEach(value => issueIds.push(value.issueId));

      if (issueIds.length === 0) {
        this.$message.warning(t("请选择要删除的问题"));
        return;
      }
      this.deleteDialogVisible = true;
    },
    deleteButtonConfirmed() {
      if (!this.itemSelected.every(issue => canDeleteIssue(issue, this.user))) return;
      this.deleteDialogVisible = false;
      let issueIds = [];

      this.itemSelected.forEach(value => issueIds.push(value.issueId));

      if (issueIds.length === 0) {
        this.$message.warning(t("请选择要删除的问题"));
        return;
      }

      axios.delete(`${app.url}/issues`, {
        data: issueIds
      }).then((response) => {
        const result = response.data || {};
        const deletedCount = result.deletedCount || 0;
        const failedCount = result.failedCount || 0;

        if (deletedCount > 0 && failedCount === 0) {
          this.$message.success(t("删除成功，共 {p0} 条", { p0: deletedCount }));
        } else if (deletedCount > 0) {
          this.$message.warning(t("部分删除成功：成功 {p0} 条，失败 {p1} 条", { p0: deletedCount, p1: failedCount }));
        } else {
          this.$message.warning(t("删除失败：共 {p0} 条未删除", { p0: failedCount }));
        }

        if (deletedCount > 0) {
          this.searchCriteriaChanged();
        }
      }).catch((error) => {
        this.$message.error(error?.response?.data?.message || t("删除失败"));
      })
    },
    changeDepartmentClicked() {
      if (!this.itemSelected.every(issue => this.canEditIssue(issue))) return;
      this.itemSelected.forEach(value => {
        app.methods.updateIssue(value.issueId, this.editIssueDialog.departmentId, () => {
          this.searchCriteriaChanged();
          this.closeEditIssueDialog();
        });
      });
    },
    openEditIssueDialog() {
      if (!this.itemSelected.every(issue => this.canEditIssue(issue))) return;
      this.editIssueDialog.visible = true;
    },
    closeEditIssueDialog() {
      this.editIssueDialog.visible = false;
    },
    activityChanged() {
      this.searchCriteria.activityId = this.activityId;
      this.searchCriteriaChanged();
    },
    issueStatusChanged() {
      if (this.issueStatus === "" || this.issueStatus === null) {
        this.searchCriteria.issueStatus = [0, 1, 2]
      } else {
        this.searchCriteria.issueStatus = [this.issueStatus];
      }

      this.searchCriteriaChanged();
    },
    departmentChanged() {
      this.searchCriteria.departmentId = this.departmentId;
      this.searchCriteriaChanged();
    },
    getIssueDepartmentLabel(issue) {
      const department = issue && issue.department ? issue.department : {};
      const names = [];
      if (Array.isArray(department.parents)) {
        department.parents.forEach((parent) => {
          if (parent && parent.name) names.push(parent.name);
        });
      } else if (department.parentName) {
        names.push(department.parentName);
      }
      if (department.name) names.push(department.name);
      return [...new Set(names)].join(' / ') || t("未分配部门");
    },
    getIssueActivityLabel(issue) {
      const activity = issue && issue.activity ? issue.activity : null;
      if (!activity) return '';
      const departmentName = activity.department
        && activity.department.parentId !== 0
        && activity.department.name;
      return departmentName
        ? `${departmentName} · ${activity.name || t("未命名活动")}`
        : (activity.name || t("未命名活动"));
    },
    isIssueOverdue(issue) {
      if (!issue || !issue.deadline || issue.issueStatus >= this.ISSUE_STATUS_ACCEPTED) {
        return false;
      }
      const datePart = String(issue.deadline).slice(0, 10);
      const deadline = new Date(`${datePart}T23:59:59.000+08:00`);
      return !Number.isNaN(deadline.getTime()) && deadline.getTime() < Date.now();
    },
    closeIssueForm(done) {
      if (!this.recordIssueSubmitting) done();
    },
    canEditIssue(issue) {
      return canEditIssue(issue, this.user);
    },
    async openIssueEditor(issue) {
      if (!this.canEditIssue(issue) || this.recordIssueSubmitting) return;
      try {
        const { data } = await axios.get(`${app.url}/issues/${issue.issueId}`);
        if (!this.canEditIssue(data)) return;
        this.resetRecordIssueForm();
        this.editingIssue = data;
        this.recordIssueForm = {
          description: data.description || '',
          images: [...(data.images || [])],
          activityId: data.activityId,
          departmentId: data.departmentId,
          issueTypeId: data.issueTypeId,
          deadline: data.deadline ? data.deadline.slice(0, 10) : null,
          mentionedUsers: [...(data.theUsersMentioned || [])],
        };
        this.recordIssueFileList = this.recordIssueForm.images.map((url, index) => ({
          name: `image-${index}`, uid: `existing-${index}`, url, status: 'success',
        }));
        this.loadIssueTypes();
        this.recordIssueDialogVisible = true;
      } catch (error) {
        this.$message.error(error?.response?.data?.message || t("问题加载失败"));
      }
    },
    openRecordIssueDialog() {
      this.resetRecordIssueForm();
      this.recordIssueDialogVisible = true;
      this.loadIssueTypes();
      const defaultDepartmentId = this.user && this.user.department ? this.user.department.departmentId : null;
      if (defaultDepartmentId) {
        this.recordIssueForm.departmentId = defaultDepartmentId;
      }
      if (!this.recordIssueForm.deadline) {
        this.recordIssueForm.deadline = this.formatDate(this.addDays(new Date(), 5));
      }
    },
    resetRecordIssueForm() {
      this.editingIssue = null;
      this.recordIssueForm = {
        description: '',
        images: [],
        activityId: null,
        departmentId: null,
        issueTypeId: null,
        deadline: null,
        mentionedUsers: [],
      };
      this.recordIssueFileList = [];
      if (this.$refs.recordIssueForm) {
        this.$refs.recordIssueForm.clearValidate();
      }
    },
    addDays(date, days) {
      const result = new Date(date);
      result.setDate(result.getDate() + days);
      return result;
    },
    loadIssueTypes() {
      if (this.issueTypes.length) return;
      app.methods.getIssueTypes().then((res) => {
        this.issueTypes = Array.isArray(res.data) ? res.data : [];
      });
    },
    fetchEmployeeOptions(keyword) {
      const query = String(keyword || '').trim();
      if (!query) {
        this.mergeEmployeeOptions([]);
        return;
      }
      this.employeeLoading = true;
      axios
          .get(`${app.url}/companies/current/users`, {params: {name: query}})
          .then((res) => {
            const employees = res?.data?.employees || [];
            this.mergeEmployeeOptions(employees);
          })
          .finally(() => {
            this.employeeLoading = false;
          });
    },
    mergeEmployeeOptions(options) {
      const merged = new Map();
      const selected = [];
      if (Array.isArray(this.recordIssueForm.mentionedUsers)) {
        selected.push(...this.recordIssueForm.mentionedUsers);
      }
      [...options, ...selected].forEach((user) => {
        if (user && user.userId != null) {
          merged.set(user.userId, user);
        }
      });
      this.employeeOptions = Array.from(merged.values());
    },
    handleIssueImageUpload(request) {
      const {file, onSuccess, onError} = request;
      app.methods
          .uploadFile(file)
          .then((url) => {
            const item = this.recordIssueFileList.find(item => item.uid === file.uid);
            if (!item) return;
            this.recordIssueForm.images.push(url);
            item.url = url;
            if (typeof onSuccess === 'function') {
              onSuccess({url});
            }
          })
          .catch((error) => {
            this.$message.error(t("图片上传失败"));
            if (typeof onError === 'function') {
              onError(error);
            }
          });
    },
    handleIssueImageChange(file, files) {
      this.recordIssueFileList = files;
    },
    handleIssueImageRemove(file, files) {
      this.recordIssueFileList = files;
      const url = file && file.url ? file.url : null;
      if (!url) return;
      this.recordIssueForm.images = this.recordIssueForm.images.filter((item) => item !== url);
      this.recordIssueFileList = this.recordIssueFileList.filter((item) => item.url !== url);
    },
    handleIssueImageExceed() {
      this.$message.warning(t("最多只能上传4张图片"));
    },
    submitRecordIssue() {
      if (this.recordIssueSubmitting) return;
      if (this.editingIssue && !this.canEditIssue(this.editingIssue)) return;
      if (this.recordIssueFileList.some(file => file.status !== 'success')) {
        this.$message.warning(t("请等待图片上传完成"));
        return;
      }
      this.$refs.recordIssueForm.validate((valid) => {
        if (!valid) return;
        const activityId = this.recordIssueForm.activityId === 0 ? null : this.recordIssueForm.activityId;
        const mentionedUsers = Array.isArray(this.recordIssueForm.mentionedUsers)
            ? this.recordIssueForm.mentionedUsers.map((user) => ({userId: user.userId, name: user.name}))
            : [];
        const payload = {
          description: this.recordIssueForm.description,
          images: this.recordIssueForm.images || [],
          activityId,
          departmentId: this.recordIssueForm.departmentId,
          issueTypeId: this.recordIssueForm.issueTypeId,
          deadline: this.recordIssueForm.deadline,
          theUsersMentioned: mentionedUsers,
        };
        const editingIssue = this.editingIssue;
        if (editingIssue) {
          payload.voiceUrl = editingIssue.voiceUrl;
          payload.voiceDurationMs = editingIssue.voiceDurationMs;
        }
        this.recordIssueSubmitting = true;
        const request = editingIssue
          ? axios.put(`${app.url}/issues/${editingIssue.issueId}`, payload)
          : axios.post(`${app.url}/issues`, payload);
        request
            .then(() => {
              this.$message.success(editingIssue ? t("保存成功") : t("记录成功"));
              this.recordIssueDialogVisible = false;
              this.searchCriteriaChanged();
            })
            .catch((error) => {
              const msg = error?.response?.data?.message || (editingIssue ? t("保存失败") : t("记录失败"));
              this.$message.error(msg);
            })
            .finally(() => {
              this.recordIssueSubmitting = false;
            });
      });
    },
    deadlineChanged(deadline) {
      this.searchCriteria.startOfDeadline = deadline ? deadline[0] : null;
      this.searchCriteria.endOfDeadline = deadline ? deadline[1] : null;
      this.searchCriteriaChanged();
    },
    getProblems(reset = false) {
      if (reset) {
        this.controller.abort()
        this.controller = new AbortController();
        this.issues = [];
        this.itemSelected = [];
        this.hasMore = true;
        this.nextCursor = null;
        this.autoSelectLoadedIssues = false;
      }
      let criteria = {
        searchStartDate: this.searchCriteria.startOfDeadline,
        searchEndDate: this.searchCriteria.endOfDeadline,
        issueStatuses: this.searchCriteria.issueStatus,
        activityId: this.searchCriteria.activityId,
        departmentId: this.searchCriteria.departmentId,
        pageSize: 20
      }
      const signal = reset ? this.controller.signal : undefined;
      app.methods.getIssues(criteria, this.nextCursor, signal).then(result => {
            const records = Array.isArray(result?.records) ? result.records : [];
            this.issues = reset ? records : this.issues.concat(records);
            if (this.autoSelectLoadedIssues) {
              this.selectLoadedIssues();
            }
            this.nextCursor = result?.nextCursor || null;
            this.hasMore = Boolean(this.nextCursor);
          }
      ).finally(() => {
        this.loadingMore = false;
      });
      app.methods
        .getCountOfAllIssues(criteria, this.controller.signal)
        .then((res) => {
          this.countOfAllIssues = 0;
          for (const statistics of res.data) {
            this.countOfAllIssues += statistics.count;
          }
          if (!this.nextCursor) {
            this.hasMore = false;
          }
        });
    },
    loadMoreIssues() {
      if (this.loadingMore || !this.hasMore) return;
      this.loadingMore = true;
      this.getProblems(false);
    },
    searchCriteriaChanged() {
      this.getProblems(true);
    },
    async getActivities() {
      if (!this.companyId) {
        this.activities = [
          {activityId: null, name: "全部", localeKey: "全部"},
          {activityId: 0, name: "无活动", localeKey: "无活动"},
        ];
        return;
      }
      let activities = (await app.methods.getActivities(this.companyId));
      activities.unshift({activityId: 0, name: "无活动", localeKey: "无活动"});
      activities.unshift({activityId: null, name: "全部", localeKey: "全部"});
      this.activities = activities;
    },
    async getDepartments() {
      if (!this.companyId) {
        this.departments = [
          {
            departmentId: 0,
            name: "未设置", localeKey: "未设置"
          }
        ];
        return;
      }
      const parentId = this.rootDepartmentId || undefined;
      const includeRoot = !this.rootDepartmentId;
      const response = await app.methods.getAllDepartmentsOfCompany(
        this.companyId,
        parentId,
        includeRoot
      );
      const departments = Array.isArray(response.data) ? response.data.slice() : [];

      if (!this.rootDepartmentId) {
        const rootIdFromUser = this.user && this.user.company ? this.user.company.rootDepartmentId : null;
        const rootFromData = Array.isArray(departments) ? departments.find(dep => dep.parentId == null) : null;
        this.rootDepartmentId = rootIdFromUser || (rootFromData && rootFromData.departmentId) || null;
      }

      departments.unshift({
        departmentId: 0,
        name: "未设置", localeKey: "未设置"
      });

      this.departments = departments;
    }
  },
  mounted() {
    window.addEventListener('export-progress', this.onExportProgress);
    this.issueEditorResizeHandler = () => {
      this.isMobileViewport = window.innerWidth <= 768;
    };
    this.issueEditorResizeHandler();
    window.addEventListener('resize', this.issueEditorResizeHandler);
  },
  beforeDestroy() {
    window.removeEventListener('export-progress', this.onExportProgress);
    if (this.issueEditorResizeHandler) {
      window.removeEventListener('resize', this.issueEditorResizeHandler);
      this.issueEditorResizeHandler = null;
    }
    if (this.scrollHandler) {
      window.removeEventListener('scroll', this.scrollHandler);
      this.scrollHandler = null;
    }
  },
  created() {
    app.methods.getUser().then((res) => {
      this.user = res.data;
      this.searchCriteriaChanged();
      this.getDepartments();
      this.getActivities();
    });
    this.scrollHandler = () => {
      if (this.loadingMore || !this.hasMore) return;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
      const fullHeight = document.documentElement.scrollHeight || document.body.scrollHeight || 0;
      if (scrollTop + viewportHeight >= fullHeight - 160) {
        this.loadMoreIssues();
      }
    };
    window.addEventListener('scroll', this.scrollHandler);
  },
}
</script>

<style scoped>
.issue-toolbar-layout {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 18px 24px;
}

.issue-filter-grid {
  display: grid;
  min-width: 0;
  flex: 1;
  grid-template-columns: minmax(260px, 1.45fr) repeat(3, minmax(150px, 1fr));
  gap: 14px;
}

.issue-filter {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 8px;
}

.issue-filter-label {
  color: var(--text-regular);
  font-size: 13px;
  font-weight: 600;
}

.issue-filter-control {
  width: 100%;
}

.issue-actions,
.issue-batch-actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.issue-actions {
  flex: 0 0 auto;
  justify-content: flex-end;
}

.issue-actions .el-button,
.issue-batch-actions .el-button {
  margin-left: 0;
}

.ppt-export {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 7px;
}

.ppt-export-progress {
  width: 150px;
}

.issue-toolbar-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  margin-top: 18px;
  padding-top: 16px;
  border-top: 1px solid var(--border-light);
}

.issue-total {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  flex: 0 0 auto;
  color: var(--text-muted);
  font-size: 13px;
}

.issue-total i {
  color: var(--primary-color);
}

.select-all-button {
  padding: 6px 0;
  border: 0;
  background: transparent;
  color: var(--primary-color);
  font: inherit;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}

.selected-count {
  color: var(--text-regular);
  font-size: 13px;
}

.select-all-button:focus-visible {
  outline: 2px solid var(--primary-color);
  outline-offset: 2px;
}

.issue-cards {
  column-count: 3;
  column-gap: 16px;
}

.issue-thread {
  display: inline-block;
  width: 100%;
  margin-bottom: 28px;
  break-inside: avoid;
  vertical-align: top;
}

.issue-thread__composer {
  position: relative;
  --composer-node-top: 30px;
  margin-left: 20px;
  padding: 16px 0 0 21px;
  border: 0;
}

.issue-thread__composer::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 1px;
  height: var(--composer-node-top);
  background: var(--border-color);
  pointer-events: none;
}

.issue-thread__composer::after {
  content: '';
  position: absolute;
  top: calc(var(--composer-node-top) - 4px);
  left: -4px;
  width: 9px;
  height: 9px;
  box-sizing: border-box;
  border: 1px solid var(--text-muted);
  border-radius: 50%;
  background: var(--page-background);
  pointer-events: none;
}

.issue-card {
  border: 1px solid var(--border-light);
  border-radius: 12px;
  display: block;
  width: 100%;
  break-inside: avoid;
  margin-bottom: 0;
  overflow: hidden;
  background: var(--surface-elevated);
  box-shadow: 0 8px 24px rgba(15, 35, 60, 0.06);
  transition:
    border-color 0.2s ease,
    box-shadow 0.2s ease,
    background-color 0.2s ease,
    transform 0.2s ease;
}

.issue-card:hover {
  border-color: var(--border-color);
  box-shadow: 0 12px 30px rgba(15, 35, 60, 0.1);
}

.issue-card--selected {
  border-color: var(--primary-color);
  background: var(--surface-selected);
  box-shadow: 0 12px 30px rgba(64, 158, 255, 0.16);
}

.issue-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-height: 32px;
  padding: 13px 16px 12px;
  border-bottom: 1px solid var(--border-light);
}

.issue-card-status {
  display: inline-flex;
  align-items: center;
  min-height: 24px;
  padding: 0 9px;
  border: 1px solid transparent;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
}

.issue-card-status--0 {
  color: var(--status-danger-text);
  background: rgba(232, 87, 87, 0.1);
  border-color: rgba(232, 87, 87, 0.22);
}

.issue-card-status--1 {
  color: var(--status-warning-text);
  background: rgba(220, 139, 32, 0.11);
  border-color: rgba(220, 139, 32, 0.24);
}

.issue-card-status--2 {
  color: var(--status-success-text);
  background: rgba(54, 162, 105, 0.11);
  border-color: rgba(54, 162, 105, 0.24);
}

.issue-card-header-actions {
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

.issue-edit-trigger.el-button {
  margin: 0;
  padding: 7px;
  background-color: var(--primary-soft);
  border-color: var(--primary-color);
  color: var(--primary-color);
}

.issue-edit-trigger.el-button:hover,
.issue-edit-trigger.el-button:focus {
  background-color: var(--surface-selected);
  border-color: var(--primary-hover);
  color: var(--primary-hover);
}

.issue-edit-trigger.el-button:focus-visible {
  outline: 2px solid var(--primary-color);
  outline-offset: 2px;
}

.issue-card-selector {
  width: 24px;
  height: 24px;
  border: 1px solid var(--border-color);
  border-radius: 999px;
  background: var(--surface-color);
  color: transparent;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  transition: border-color 0.2s ease, background-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;
}

.issue-card-selector:hover {
  border-color: var(--primary-color);
}

.issue-card-selector--selected {
  border-color: var(--primary-color);
  background: var(--primary-color);
  color: #ffffff;
  box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.12);
}

.issue-card-content {
  padding: 16px;
}

.issue-card-section-title {
  margin: 0 0 10px;
  color: var(--text-muted);
  font-size: 12px;
  font-weight: 600;
}

.issue-card-overview {
  margin: 14px 0 0;
  font-size: 12px;
  line-height: 1.65;
}

.issue-card-context,
.issue-card-timing { display: flex; flex-wrap: wrap; align-items: baseline; gap: 6px 14px; }
.issue-card-context { color: var(--text-regular); }
.issue-card-timing { margin-top: 7px; color: var(--text-muted); font-size: 11px; }
.issue-card-department,
.issue-card-person,
.issue-card-deadline { display: inline-flex; align-items: baseline; gap: 5px; min-width: 0; max-width: 100%; }
.issue-card-department { font-weight: 500; }
.issue-card-overview span { overflow-wrap: anywhere; }
.issue-card-overview i { flex-shrink: 0; color: var(--text-muted); }
.issue-card-meta-label { flex-shrink: 0; color: var(--text-muted); font-weight: 400; }
.issue-card-recorded { min-width: 0; max-width: 100%; }
.issue-card-recorder-name { color: var(--text-regular); }
.issue-card-deadline { color: var(--text-regular); }

.issue-card-description {
  white-space: pre-wrap;
  color: var(--text-primary);
  font-size: 15px;
  font-weight: 600;
  line-height: 1.65;
  overflow-wrap: anywhere;
}

.issue-card-description--empty {
  color: var(--text-muted);
  font-weight: 400;
}

.issue-card-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 12px;
}

.issue-card-tag {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  max-width: 100%;
  min-height: 25px;
  padding: 0 9px;
  border-radius: 999px;
  background: rgba(64, 158, 255, 0.11);
  color: var(--primary-color);
  font-size: 12px;
  line-height: 1.3;
}

.issue-card-tag--activity {
  background: var(--surface-hover);
  color: var(--text-regular);
}

.issue-card-images {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 7px;
  margin-top: 14px;
}

.issue-card-image {
  position: relative;
  width: 100%;
  padding-top: 100%;
  border-radius: 7px;
  overflow: hidden;
  border: 1px solid var(--border-light);
  background: var(--surface-hover);
}

.issue-card-image .el-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  cursor: zoom-in;
}

.issue-card-image-more {
  pointer-events: none;
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(8, 15, 25, 0.58);
  color: #ffffff;
  font-size: 16px;
  font-weight: 600;
}

.issue-card-deadline--overdue,
.issue-card-deadline--overdue i {
  color: var(--status-danger-text);
  font-weight: 600;
}

.issue-empty {
  text-align: center;
  color: var(--text-muted);
  font-size: 13px;
  padding: 16px 0 8px;
}

.load-more {
  display: flex;
  justify-content: center;
  padding: 16px 0 8px;
}

.load-more-spinner {
  font-size: 18px;
  color: var(--text-muted);
}

.load-more-tip {
  color: var(--text-muted);
  font-size: 12px;
}

@media (max-width: 1200px) {
  .issue-toolbar-layout {
    align-items: stretch;
    flex-direction: column;
  }

  .issue-actions {
    justify-content: flex-start;
  }

  .issue-cards {
    column-count: 2;
  }
}

@media (max-width: 768px) {
  .issue-filter-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .issue-filter--date {
    grid-column: 1 / -1;
  }

  .issue-toolbar-meta {
    align-items: flex-start;
    flex-direction: column;
  }

  .issue-actions {
    display: grid;
    width: 100%;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .issue-actions > .el-button,
  .issue-actions > .ppt-export,
  .ppt-export > .el-button {
    width: 100%;
  }

  .issue-actions > .el-button,
  .ppt-export > .el-button {
    margin: 0;
  }

  .ppt-export-progress {
    width: 100%;
  }

  .issue-cards {
    column-count: 1;
    column-gap: 0;
  }
  .issue-thread { margin-bottom: 24px; }
  .issue-thread__composer { --composer-node-top: 28px; margin-left: 16px; padding: 14px 0 0 19px; }
  .issue-card:hover {
    transform: none;
  }
  .issue-card-header,
  .issue-card-content {
    padding-left: 14px;
    padding-right: 14px;
  }
}

@media (max-width: 520px) {
  .issue-filter-grid {
    grid-template-columns: minmax(0, 1fr);
  }

  .issue-filter--date {
    grid-column: auto;
  }

  .issue-actions {
    grid-template-columns: minmax(0, 1fr);
  }

  .issue-batch-actions {
    width: 100%;
  }

  .issue-batch-actions .el-button {
    flex: 1;
  }
}

@media (prefers-reduced-motion: reduce) {
  .issue-card {
    transition: none;
  }
}
</style>

<style>
.issue-editor-panel {
  background-color: var(--surface-elevated);
  color: var(--text-primary);
}
.issue-editor-panel .el-drawer__header {
  margin-bottom: 0;
  padding: 24px;
  border-bottom: 1px solid var(--border-light);
  color: var(--text-primary);
  font-weight: 600;
}
.issue-editor-panel .el-drawer__close-btn {
  color: var(--text-regular);
}
.issue-editor-panel .el-drawer__close-btn:hover,
.issue-editor-panel .el-drawer__close-btn:focus {
  color: var(--primary-color);
}
.issue-editor-panel .el-upload--picture-card,
.issue-editor-panel .el-upload-list--picture-card .el-upload-list__item {
  background-color: var(--surface-color);
  border-color: var(--border-color);
}
.issue-editor-panel .el-upload--picture-card i {
  color: var(--text-muted);
}
.issue-editor-panel .el-upload--picture-card:hover,
.issue-editor-panel .el-upload--picture-card:focus {
  border-color: var(--primary-color);
}
.issue-editor-panel .el-drawer__body {
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}
.issue-editor-panel .el-form {
  flex: 1;
  overflow-y: auto;
  padding: 24px;
}
.issue-editor-panel .el-select,
.issue-editor-panel .el-date-editor { width: 100%; }
.issue-editor-footer {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  padding: 16px 24px;
  padding-bottom: max(16px, env(safe-area-inset-bottom));
  border-top: 1px solid var(--border-light);
  background: var(--surface-elevated);
}
.issue-editor-panel--mobile.el-dialog {
  display: flex;
  width: 100%;
  max-width: none;
  height: 100%;
  min-height: 100dvh;
  margin: 0 !important;
  flex-direction: column;
  overflow: hidden;
  border-radius: 0;
}
.issue-editor-panel--mobile .el-dialog__header {
  flex: 0 0 auto;
  margin: 0;
  padding: max(16px, env(safe-area-inset-top)) 52px 16px 16px;
  border-bottom: 1px solid var(--border-light);
}
.issue-editor-panel--mobile .el-dialog__title {
  color: var(--text-primary);
  font-size: 18px;
  font-weight: 600;
}
.issue-editor-panel--mobile .el-dialog__headerbtn {
  top: max(18px, env(safe-area-inset-top));
  right: 16px;
}
.issue-editor-panel--mobile .el-dialog__body {
  display: flex;
  flex: 1;
  min-height: 0;
  flex-direction: column;
  overflow: hidden;
  padding: 0;
  color: var(--text-primary);
}
.issue-editor-panel--mobile .el-form {
  padding: 16px;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
}
.issue-editor-panel--mobile .el-form-item__label {
  padding-bottom: 6px;
  line-height: 1.4;
}
.issue-editor-panel--mobile .el-dialog__footer {
  flex: 0 0 auto;
  padding: 0;
}
.issue-editor-panel--mobile .issue-editor-footer {
  padding: 12px 16px;
  padding-bottom: max(12px, env(safe-area-inset-bottom));
}
.issue-editor-panel--mobile .issue-editor-footer .el-button {
  flex: 1;
  margin-left: 0;
}
.issue-editor-panel--mobile .el-upload--picture-card,
.issue-editor-panel--mobile .el-upload-list--picture-card .el-upload-list__item {
  width: 96px;
  height: 96px;
  line-height: 96px;
}
</style>
